import { FiSettings, FiMoon, FiSun, FiUsers } from 'react-icons/fi';
import { usePreferences } from '../../contexts/PreferencesContext';
import { useOnlineUsers } from '../../contexts/OnlineUsersContext';
import styles from './DashboardHeader.module.css';

const DashboardHeader = ({ user, onOptionsClick, onOnlineToggle, showOnlineWidget }) => {
  const { themeMode, toggleThemeMode } = usePreferences();
  const { onlineCount } = useOnlineUsers();

  return (
    <header className={styles.header}>
      <div className={styles.user}>
        {user?.avatar_emoji} {user?.tagname}
      </div>
      <div className={styles.actions}>
        <button 
          className={`${styles.iconBtn} ${showOnlineWidget ? styles.active : ''}`}
          onClick={onOnlineToggle}
          title="Online-User anzeigen"
        >
          <FiUsers />
          {onlineCount > 0 && (
            <span className={styles.badge}>{onlineCount}</span>
          )}
        </button>
        <button className={styles.iconBtn} onClick={toggleThemeMode}>
          {themeMode === 'dark' ? <FiSun /> : <FiMoon />}
        </button>
        <button className={styles.iconBtn} onClick={onOptionsClick}>
          <FiSettings />
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;